/* Dot-grid background — canvas substrate adapted from Beautiful Systems
   (v5-styles 06/muse-spark-13/04-beautiful-systems, script.js substrate only).
   Fixed full-viewport grid of small stone dots; dots near the cursor glow orange.
   Deliberately omitted: telemetry crosshair, coordinate readout, clock, noise overlay.
   Static grid renders on every device; cursor tracking only on fine pointers. */
(() => {
  const canvas = document.getElementById('dot-grid');
  const ctx = canvas?.getContext('2d');
  if (!canvas || !ctx) return;

  const STEP = 32, RADIUS = 140;
  const FINE_POINTER = window.matchMedia
    ? window.matchMedia('(pointer: fine)')
    : { matches: true };
  let W = 0, H = 0, DPR = 1, mx = -9999, my = -9999, hasPointer = false;
  let drawQueued = false;

  // Tailwind steps as canvas RGB triplets (see palette discipline in design-specs.md):
  // rest dots stone-500 both themes, highlight orange-600 both themes.
  function themeColors() {
    const dark = document.documentElement.getAttribute('data-theme') !== 'light';
    return {
      dot: '120,113,108',
      hot: '234,88,12',
      restAlpha: dark ? 0.45 : 0.5,
    };
  }

  function draw() {
    drawQueued = false;
    const C = themeColors();
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.clearRect(0, 0, W, H);
    for (let y = STEP / 2; y < H; y += STEP) {
      for (let x = STEP / 2; x < W; x += STEP) {
        let alpha = C.restAlpha, size = 1.5, fill = C.dot;
        if (hasPointer) {
          const d = Math.hypot(x - mx, y - my);
          if (d < RADIUS) {
            const k = 1 - d / RADIUS;
            alpha = C.restAlpha + (0.85 - C.restAlpha) * k;
            if (k > 0.55) fill = C.hot;
            if (k > 0.8) size = 2;
          }
        }
        ctx.fillStyle = `rgba(${fill},${alpha.toFixed(3)})`;
        ctx.fillRect(x - size / 2, y - size / 2, size, size);
      }
    }
  }

  function requestDraw() {
    if (drawQueued) return;
    drawQueued = true;
    requestAnimationFrame(draw);
  }

  function resize() {
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = Math.floor(W * DPR); canvas.height = Math.floor(H * DPR);
    canvas.style.width = `${W}px`; canvas.style.height = `${H}px`;
    requestDraw();
  }

  if (FINE_POINTER.matches) {
    window.addEventListener('pointermove', (e) => {
      mx = e.clientX; my = e.clientY; hasPointer = true;
      requestDraw();
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', () => {
      hasPointer = false; mx = -9999; my = -9999; requestDraw();
    });
  }

  // Redraw on theme flip (theme.js toggles data-theme on <html>).
  new MutationObserver((mutations) => {
    if (mutations.some((m) => m.attributeName === 'data-theme')) requestDraw();
  }).observe(document.documentElement, { attributes: true });

  window.addEventListener('resize', resize, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') requestDraw();
  });

  resize();
})();
